export default "__VITE_ASSET__DMA_UCFI__"